<h3 class="case-data__title">{{ 'title.case_data' | translate | uppercase }}</h3>
<p class="case-data__description">{{ 'case_data_manager.description' | translate }}</p>

<ng-container *ngIf="rows$ | async as rows">
  <div class="case-data__empty" *ngIf="rows.length === 0" data-cy="case-data-empty">
    {{ 'case_data_manager.empty' | translate }}
  </div>

  <ul
    class="case-data__list"
    *ngIf="rows.length > 0"
    cdkDropList
    [cdkDropListData]="rows"
    [cdkDropListSortPredicate]="sortPredicate"
    (cdkDropListDropped)="onDrop(rows, $event)"
  >
    <li
      class="case-data__row"
      *ngFor="let row of rows; trackBy: trackByIndex"
      cdkDrag
      [cdkDragDisabled]="pendingRemovalIndex !== null || !row.canReorder"
      cdkDragLockAxis="y"
      data-cy="case-data-row"
    >
      <i class="case-data__icon" [ngClass]="row.icon"></i>
      <span class="case-data__name">{{ row.displayName }}</span>
      <i
        class="ri-spy-line case-data__encrypted"
        *ngIf="row.encrypted"
        [matTooltip]="'tooltip.encrypted_field' | translate"
      ></i>

      <span class="case-data__confirm-text" *ngIf="pendingRemovalIndex === row.index">
        {{ 'case_data_manager.confirm_remove' | translate }}
      </span>

      <ng-container *ngIf="pendingRemovalIndex !== row.index; else confirmActions">
        <span class="case-data__actions">
          <button type="button" class="icon-button" (click)="onEdit(row)" data-cy="case-data-edit">
            <i class="ri-pencil-line"></i>
          </button>
          <button
            type="button"
            class="icon-button icon-button--danger"
            *ngIf="row.canRemove"
            (click)="requestRemove(row)"
            data-cy="case-data-remove"
          >
            <i class="ri-close-line"></i>
          </button>
        </span>
      </ng-container>

      <ng-template #confirmActions>
        <span class="case-data__actions">
          <button type="button" class="btn btn-flat" (click)="cancelRemove()" data-cy="case-data-remove-cancel">
            {{ 'button.cancel' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-danger"
            (click)="confirmRemove(row)"
            data-cy="case-data-remove-confirm"
          >
            {{ 'button.confirm' | translate }}
          </button>
        </span>
      </ng-template>
    </li>
  </ul>
</ng-container>

<button type="button" class="btn btn-primary btn-block case-data__add" (click)="onAdd()" data-cy="case-data-add">
  <i class="ri-add-circle-line"></i>
  {{ 'case_data_manager.add_field' | translate }}
</button>
